import { mapAuditLogChangedField } from './mapAuditLogChangedFieldApiModel'
import { type AuditLogRecordConstructorData } from '../../entities/AuditLogRecord'
import { type AuditLogChangedFieldApiModel } from '../api-models/AuditLogChangedFieldApiModel'
import { type AuditLogRecordApiModel } from '../api-models/AuditLogRecordApiModel'

export const mapChangedByUser = (changedByUser: {
  id: number
  firstName: string
  lastName: string
  email: string
}) => ({
  id: changedByUser.id,
  firstName: changedByUser.firstName,
  lastName: changedByUser.lastName,
  email: changedByUser.email,
  profileImage: null,
})

const normalizeRawChanges = (
  rawChanges: AuditLogRecordApiModel['raw_changes']
): AuditLogChangedFieldApiModel[] =>
  Array.isArray(rawChanges) ? rawChanges : []

export const mapTitle = (
  changes: string[],
  rawChanges: AuditLogChangedFieldApiModel[]
) => {
  if (rawChanges.length > 0) {
    return rawChanges[0].item
  } else {
    return changes[0]
  }
}

export const mapAuditLogRecordApiModel = (
  auditLogRecord: AuditLogRecordApiModel
): AuditLogRecordConstructorData => {
  const rawChanges = normalizeRawChanges(auditLogRecord.raw_changes)

  return {
    changedOn: auditLogRecord.changed_on,
    changedBy: mapChangedByUser(auditLogRecord.changed_by),
    title: mapTitle(auditLogRecord.changes, rawChanges),
    changedFields: rawChanges.map((rawChange) =>
      mapAuditLogChangedField(rawChange)
    ),
    status: auditLogRecord.tag,
    delegatee: auditLogRecord.metadata?.delegatee
      ? mapChangedByUser(auditLogRecord.metadata.delegatee)
      : undefined,
  }
}
